var _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaunchGlow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 285,
    height: 235,
    viewBox: "0 0 285 235",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter0_f_4516_410958)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 129.5,
    cy: 43.5,
    r: 40.5,
    fill: "url(#paint0_radial_4516_410958)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter1_f_4516_410958)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 165,
    cy: 115,
    r: 72,
    fill: "url(#paint1_radial_4516_410958)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter2_f_4516_410958)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 88.5,
    cy: 105.5,
    r: 40.5,
    fill: "url(#paint2_radial_4516_410958)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4516_410958",
    x: 41,
    y: -45,
    width: 177,
    height: 177,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 24,
    result: "effect1_foregroundBlur_4516_410958"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_4516_410958",
    x: 45,
    y: -5,
    width: 240,
    height: 240,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 24,
    result: "effect1_foregroundBlur_4516_410958"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_4516_410958",
    x: 0,
    y: 17,
    width: 177,
    height: 177,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 24,
    result: "effect1_foregroundBlur_4516_410958"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4516_410958",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(129.5 43.5) rotate(90) scale(40.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#04D1C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBFFFD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_4516_410958",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(165 115) rotate(90) scale(72)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#04D1C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBFFFD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_4516_410958",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(88.5 105.5) rotate(90) scale(40.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#04D1C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBFFFD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaunchGlow);
export default __webpack_public_path__ + "static/media/launch-glow.512cebd8a1e83693781bc56e9ec88e8c.svg";
export { ForwardRef as ReactComponent };